export const CREATE_BOOK_FORM = "book-form/create";
export const UPDATE_STATUS = "book-form/updateStatus";
export const getBookFormsEndpoint = (page:number, rows:number) => (
    `book-form?fields=${JSON.stringify({ page, rows })}`
);
export const getBookFormVideoURLEndpoint = (key:string, userId:string) : string => (
    `book-form/video-url?key=${key}&userId=${userId}`
)